module.exports = __webpack_public_path__ + "img/happy.9a8ff31.svg";